import moment from "moment";

/**
 * Converts Firestore Timestamp, ISO string, or Date to a moment for comparison.
 * @param {import("firebase/firestore").Timestamp | string | Date | null | undefined} value
 * @returns {moment.Moment | null}
 */
export function momentFromClientDate(value) {
  if (value == null) {
    return null;
  }
  if (
    typeof value === "object" &&
    value.seconds !== undefined &&
    typeof value.seconds === "number"
  ) {
    return moment(value.seconds * 1000);
  }
  return moment(value);
}

/**
 * True when the stored date is the same calendar day as today (local timezone).
 * Used for dashboard "Today" filters and optional balance receivable follow-up date.
 * @param {import("firebase/firestore").Timestamp | string | Date | null | undefined} value
 * @returns {boolean}
 */
export function isSameCalendarDayAsToday(value) {
  const m = momentFromClientDate(value);
  if (!m || !m.isValid()) {
    return false;
  }
  return m.startOf("day").isSame(moment().startOf("day"), "day");
}
